export const AdminMenu = [
  {
    is_header: true,
    title: "Menu",
  },
  {
    paths: ["/admin/main"],
    icon: "fa fa-desktop",
    title: "매인",
  },
  {
    paths: [
      "/admin/users",
      "/admin/users/:id",
      "/admin/withdrawals",
      "/admin/withdrawals/:id",
    ],
    icon: "fa fa-users",
    title: "회원",
    children: [
      {
        paths: ["/admin/users", "/admin/users/:id"],
        title: "회원",
      },
      {
        paths: ["/admin/withdrawals", "/admin/withdrawals/:id"],
        title: "탈퇴",
      },
    ],
  },
  {
    paths: [
      "/admin/media",
      "/admin/media/new",
      "/admin/media/:id",
      "/admin/news",
      "/admin/news/new",
      "/admin/news/:id",
    ],
    icon: "fa fa-chalkboard",
    title: "게시글",
  },
  {
    paths: ["/admin/logs"],
    icon: "fa fa-list-ol",
    title: "로그",
  },
  {
    paths: ["/admin/stores"],
    icon: "fa fa-store",
    title: "매장 관리",
  },

  // 스탬프 투어, 가게 대기
  // {
  //   paths: [
  //     "/admin/stamptours",
  //     "/admin/stamptours/:id",
  //     "/admin/shops",
  //     "/admin/shops/:id",
  //   ],
  //   icon: "fa fa-stamp",
  //   title: "스탬프 투어",
  //   children: [
  //     {
  //       paths: ["/admin/stamptours", "/admin/stamptours/:id"],
  //       title: "스탬프 투어",
  //     },
  //     { paths: ["/admin/shops", "/admin/shops/:id"], title: "가게" },
  //   ],
  // },

  // 댑스 예제 코드
  // {
  //   path: "/users",
  //   icon: "fa fa-users",
  //   title: "매장",
  //   children: [
  //     {
  //       path: "/menu/menu-1-1",
  //       title: "Menu 1.1",
  //       children: [
  //         {
  //           path: "/menu/menu-1-1/menu-2-1",
  //           title: "Menu 2.1",
  //           children: [
  //             { path: "/menu/menu-1-1/menu-2-1/menu-3-1", title: "Menu 3.1" },
  //             { path: "/menu/menu-1-1/menu-2-1/menu-3-2", title: "Menu 3.2" },
  //           ],
  //         },
  //         { path: "/menu/menu-1-1/menu-2-2", title: "Menu 2.2" },
  //         { path: "/menu/menu-1-1/menu-2-3", title: "Menu 2.3" },
  //       ],
  //     },
  //     { path: "/menu/menu-1-2", title: "Menu 1.2" },
  //     { path: "/menu/menu-1-3", title: "Menu 1.3" },
  //   ],
  // },
];
